import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { CompanyAiActionsPage } from '../features/ai/company-ai-actions-page';
import type { CompanyAiActionsSearch } from '../features/ai/company-ai-actions-page';

const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  status: z.enum(['PENDING_REVIEW', 'BUILDING', 'BUILT', 'REJECTED', 'BUILD_FAILED']).optional().catch(undefined),
  q: z.string().trim().max(120).optional().catch(undefined),
  sort: z.enum(['newest', 'oldest', 'title']).optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/ai-actions')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});

function RouteComponent() {
  const { companySlug } = Route.useParams();
  const search: CompanyAiActionsSearch = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CompanyAiActionsPage
      companySlug={companySlug}
      onFilterChange={(status) =>
        void navigate({
          search: (previous) => ({
            page: 1,
            pageSize: previous.pageSize,
            ...(status ? { status } : {}),
            ...(previous.q ? { q: previous.q } : {}),
            ...(previous.sort ? { sort: previous.sort } : {}),
          }),
        })
      }
      onStatusChange={(status) => void navigate({ search: (previous) => ({ ...previous, page: 1, status }) })}
      onSearchChange={(q) => void navigate({ search: (previous) => ({ ...previous, page: 1, q: q || undefined }) })}
      onSortChange={(sort) => void navigate({ search: (previous) => ({ ...previous, page: 1, sort }) })}
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      search={search}
    />
  );
}
